import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import Keycloak, { KeycloakProfile } from 'keycloak-js';
import { from, of } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';
import * as UserActions from './user.actions';
import { User } from './user.model';

async function waitForKeycloakReady(keycloak: Keycloak): Promise<void> {
  const timeoutMs = 10_000;
  const pollMs = 50;
  const startedAt = Date.now();

  while (!keycloak.didInitialize && Date.now() - startedAt < timeoutMs) {
    await new Promise((resolve) => setTimeout(resolve, pollMs));
  }
}

@Injectable()
export class UserEffects {

  private actions$ = inject(Actions);
  private keycloak = inject(Keycloak);

  loadUser$ = createEffect(() => this.actions$.pipe(
    ofType(UserActions.loadUser),
    switchMap(() =>
      from(waitForKeycloakReady(this.keycloak)).pipe(
        switchMap(() =>
          from(this.keycloak.loadUserProfile() as Promise<KeycloakProfile>).pipe(
            map((profile) => {
              const realmAccess = this.keycloak.realmAccess;
              const userRoles = realmAccess?.roles || [];
              const user = new User(
                profile,
                userRoles,
                this.keycloak.tokenParsed as any
              );
              return UserActions.loadUserSuccess({ user });
            }),
            catchError(error => of(UserActions.loadUserFailure({ error })))
          )
        )
      )
    )
  ));
}
